<template lang="pug">
.error-auth.text-large
  .error-auth__message システム連携に失敗しました。システム管理者に問い合わせをお願いします。
  a(:href='returnPage') 戻る
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'

@Component
export default class ErrorAuth extends Vue {
  private get returnPage(): string {
    return this.$bcbtCookies.returnUrl.get()
  }
}
</script>

<style lang="stylus" scoped>
.error-auth
  margin 50px

  &__message
    margin-bottom 20px
</style>
